import type {CopilotChatModel} from '@github-ui/copilot-chat-types'
import {LOGO_BY_VENDOR} from '@github-ui/copilot-shared-ui/agents/use-agent-models'

export const AUTO_MODEL_ID = 'auto'

function createAutoModel(vendorFilters?: string[]): CopilotChatModel {
  let vendor = ''
  let logoURL: string | undefined
  if (vendorFilters) {
    for (const vendorFilter of vendorFilters) {
      for (const [name, url] of LOGO_BY_VENDOR) {
        if (name.toLowerCase() === vendorFilter.toLowerCase()) {
          vendor = name
          logoURL = url
          break
        }
      }
      if (logoURL) break
    }
  }

  return {
    id: AUTO_MODEL_ID,
    name: 'Auto',
    displayName: 'Auto',
    hasLimitedCapabilities: false,
    isThirdParty: false,
    version: '',
    vendor,
    logoURL,
    preview: false,
    model_picker_enabled: true,
    capabilities: {
      type: 'chat',
      family: '',
      limits: {max_prompt_tokens: 0},
      supports: {},
      tokenizer: '',
    },
  }
}

function brandAutoModel(autoModel: CopilotChatModel, vendorFilterLower: string): CopilotChatModel {
  if (autoModel.logoURL) return autoModel
  for (const [name, url] of LOGO_BY_VENDOR) {
    if (name.toLowerCase() === vendorFilterLower) {
      return {...autoModel, vendor: name, logoURL: url}
    }
  }
  return autoModel
}

export function getAvailableAgentModels(allModels: CopilotChatModel[], vendorFilters?: string[]): CopilotChatModel[] {
  if (!vendorFilters || vendorFilters.length === 0) return allModels

  const filtersLower = vendorFilters.map(vendor => vendor.toLowerCase())
  const filtered = allModels.filter(model => filtersLower.some(filter => model.vendor?.toLowerCase().includes(filter)))
  const autoModel = allModels.find(model => model.id === AUTO_MODEL_ID)
  if (filtered.length === 0) return autoModel ? [autoModel] : [createAutoModel(vendorFilters)]

  const primaryVendor = filtersLower[0]
  const brandedAuto = autoModel && primaryVendor ? brandAutoModel(autoModel, primaryVendor) : undefined
  return brandedAuto ? [brandedAuto, ...filtered] : filtered
}
